var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      attrs: {
        "md-active": _vm.isShowAxiosLoading,
        "md-close-on-esc": false,
        "md-click-outside-to-close": false
      },
      on: {
        "update:mdActive": function($event) {
          _vm.isShowAxiosLoading = $event
        }
      }
    },
    [
      _c("img", {
        staticClass: "text-center",
        attrs: { src: require("../../assets/img/loading.gif"), alt: "" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0124ac15", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0124ac15","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/globals/AxiosLoading.vue
// module id = null
// module chunks = 